export const operators = [
  {value: '=', label: '='},
  {value: '!=', label: '≠'},
  {value: '<', label: '<'},
  {value: '<=', label: '≤'},
  {value: '>', label: '>'},
  {value: '>=', label: '≥'},
  {value: 'isNull', label: 'no value'},
];

export function getFormattedValue(field, filter) {
  if (filter.operator === '=') {
    return filter.value;
  } else if (filter.operator === 'isNull') {
    return 'no value';
  } else {
    const operatorLabel = operators.find(o => o.value === filter.operator).label;
    return `${operatorLabel} ${filter.value}`;
  }
}

export function isValid(filter) {
  if (filter.operator === 'isNull') {
    return true;
  } else {
    return filter.value !== null
      && filter.value.length > 0;
  }
}

export function getApiParam(field, filter) {
  switch (filter.operator) {
    case null:
    case '=':
      return filter.value;
    case '!=':
      return `not(${filter.value})`
    case '<':
      return `lt(${filter.value})`;
    case '<=':
      return `lte(${filter.value})`;
    case '>':
      return `gt(${filter.value})`;
    case '>=':
      return `gte(${filter.value})`;
    case 'isNull':
      return 'is(null)';
  }

}


